<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <path d="M44.1,6.8H5.9c-1.9,0-3.5,1.6-3.5,3.5v6.3c0,1.9,1.6,3.5,3.5,3.5h38.2c1.9,0,3.5-1.6,3.5-3.5v-6.3c0-1.9-1.6-3.5-3.5-3.5ZM5.4,16.7v-6.3c0-.3.2-.5.5-.5h17.6v7.4H5.9c-.3,0-.5-.2-.5-.5ZM44.6,16.7c0,.3-.2.5-.5.5h-17.6v-7.4h17.6c.3,0,.5.2.5.5v6.3Z"/>
        <path d="M44.1,21.8H5.9c-1.9,0-3.5,1.6-3.5,3.5v5.3c0,1.9,1.6,3.5,3.5,3.5h14.3c.8,0,1.5-.7,1.5-1.5s-.7-1.5-1.5-1.5H5.9c-.3,0-.5-.2-.5-.5v-5.3c0-.3.2-.5.5-.5h38.2c.3,0,.5.2.5.5v5.3c0,.3-.2.5-.5.5h-14.2c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5h14.2c1.9,0,3.5-1.6,3.5-3.5v-5.3c0-1.9-1.6-3.5-3.5-3.5Z"/>
        <path d="M26.9,37.6l-.4.4v-10.6c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5,1.5v10.6l-.4-.4c-.6-.6-1.5-.6-2.1,0s-.6,1.5,0,2.1l3,3c.3.3.7.4,1.1.4s.8-.1,1.1-.4l3-3c.6-.6.6-1.5,0-2.1s-1.5-.6-2.1,0Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>